import React from 'react';
import { Button } from '../ui/Button';
export function Solution() {
  return <section className="py-10 px-4 bg-blue-50" data-id="element-128">
      <div className="max-w-4xl mx-auto" data-id="element-129">
        <div className="bg-white border-4 border-blue-500 rounded-2xl p-6 md:p-10 text-center shadow-md relative overflow-hidden mb-10" data-id="element-130">
          <div className="absolute top-0 left-0 w-full h-2 bg-blue-500" data-id="element-131"></div>

          <h2 className="text-yellow-500 font-black text-2xl md:text-3xl mb-1 uppercase tracking-wide" data-id="element-132">
            💛 PRESENTAMOS:
          </h2>
          <h3 className="text-3xl md:text-5xl font-bold text-gray-900 mb-5" data-id="element-133">
            MEGAPACK DORMIR MEJOR DESDE EL AMOR
          </h3>

          <p className="text-xl text-gray-700 mb-4 font-medium" data-id="element-134">
            Un sistema paso a paso diseñado para ayudarte a:
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-6 text-left max-w-2xl mx-auto" data-id="element-135">
            {['Reducir despertares nocturnos', 'Lograr siestas más largas', 'Dormir a tu bebé sin llanto', 'Recuperar descanso y calma'].map((item, i) => <div key={i} className="bg-gray-50 p-3 rounded-lg border flex items-center gap-3" data-id="element-136">
                <span className="text-green-500 font-bold" data-id="element-137">✔</span>
                <span className="font-semibold text-gray-800" data-id="element-138">{item}</span>
              </div>)}
          </div>

          <p className="text-lg font-bold text-blue-800 bg-blue-100 p-3 rounded-lg inline-block mb-6" data-id="element-139">
            Incluso si hoy tu bebé depende 100% de vos para dormir
          </p>

          <div data-id="element-140">
            <Button href="https://checkout.mediosdigitalespro.online/cart/42525422551111:1" size="xl" className="w-full md:w-auto" data-id="element-141">
              👉 QUIERO EMPEZAR HOY MISMO
            </Button>
          </div>
        </div>

        <div className="bg-white p-6 md:p-10 rounded-2xl shadow-sm border border-gray-100" data-id="element-142">
          <h3 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-4" data-id="element-143">
            🔑 ¿POR QUÉ ESTE MÉTODO FUNCIONA?
          </h3>

          <p className="text-xl text-center text-gray-700 mb-6 font-medium" data-id="element-144">
            Porque no intenta "forzar" el sueño
          </p>

          <p className="text-lg font-bold text-gray-900 mb-3 text-center" data-id="element-145">
            Trabaja con la biología real del bebé:
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-6 max-w-xl mx-auto" data-id="element-146">
            {['Ritmos naturales', 'Regulación emocional', 'Señales de sueño', 'Acompañamiento seguro'].map((item, i) => <div key={i} className="flex items-center gap-2 text-gray-700" data-id="element-147">
                <span className="text-green-500 font-bold" data-id="element-148">✔</span>
                <span className="font-medium" data-id="element-149">{item}</span>
              </div>)}
          </div>

          <div className="text-center bg-yellow-50 p-4 rounded-xl border border-yellow-200" data-id="element-150">
            <p className="text-lg text-gray-800 font-medium" data-id="element-151">
              No es un ebook más
            </p>
            <p className="font-bold text-xl text-gray-900 mt-1" data-id="element-152">
              👉 Es un sistema claro que sabés exactamente cómo aplicar
            </p>
          </div>
        </div>
      </div>
    </section>;
}